import "./index.css";
import { initializeIntercom } from "./services/intercom";
import AppContainer from "./AppContainer";
import { initAnalytics } from "./services/analytics";
import "@react-page/editor/lib/index.css";
import "@react-page/plugins-slate/lib/index.css";
import "@react-page/plugins-divider/lib/index.css";
import "@react-page/plugins-background/lib/index.css";
import "@react-page/plugins-video/lib/index.css";
import "@react-page/plugins-spacer/lib/index.css";
import "./i18n";
import { createRoot } from "react-dom/client";
import { hydrateSessionStorage } from "utils/storage";
import { injectScript } from "./utils/scriptInjector";
import Configuration from "./config";

initAnalytics();

hydrateSessionStorage();

// Check Microsoft Clarity configuration before injecting the script
if (Configuration.MICROSOFT_CLARITY.script) {
  injectScript(Configuration.MICROSOFT_CLARITY.script);
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<AppContainer />);

initializeIntercom();
